import { LandingPage } from '@changegps/horizon-component-library';
import { Typography } from '@mui/material';

export const AppSubscriptionError = () => {
  return (
    <LandingPage>
      <Typography>
        Your subscription for ChangeGPS currently has an issue.
      </Typography>
      <Typography>
        Please contact your administrator to restore access.
      </Typography>
    </LandingPage>
  );
};
